export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/chevron-right-white.png?56e86e127cf2dd6457b56e621ab05124";